import { SVGAttributes } from "react";

const AgntAmbassadorIcon = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.1803 6.18515H1.5V8.80135H5.44532L7.83048 10.8943V4.09219L5.1803 6.18515Z"
        fill="#FFA686"
        stroke="#FFA686"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 9L3.5 12"
        stroke="#FFA686"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.865 4.46853C13.5392 6.14277 13.5392 8.85723 11.865 10.5315"
        stroke="#CFB2FF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 2C17.5376 5.03757 17.5376 9.96243 14.5 13"
        stroke="#CFB2FF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AgntAmbassadorIcon;
